/* eslint-disable */

/**
 * This holds information about the current version of the passwords and if it is now empty.
 *
 * This information is used to reset enclave tokens on password change and to change what is
 * is displayed on the settings page.
 */
export interface PasswordInfo {
  version?: number;
  has_password?: boolean;
}

/**
 * This holds information about OTP and whether or not it is enabled for a
 * user's account. This value is responsible for showing the current OTP state
 * on the security and privacy screen.
 */
export interface OTPInfo {
  otp_enabled?: boolean;
}

/** This holds information about a Managed Device. */
export interface DeviceInfo {
  last_login_at?: number;
  last_login_location?: string;
  device_name?: string;
  /** The app_token hashed with SHA256 */
  hashed_app_token?: string;
  device_type?: DeviceInfoDeviceType;
  last_login_location_image_url?: string;
  status?: DeviceInfoStatus;
  /** When did the user verify that this device is ok to be logged in to the account, if they ever have */
  verified_at?: number;
}

export enum DeviceInfoDeviceType {
  MAC = "MAC",
  WINDOWS = "WINDOWS",
  ANDROID = "ANDROID",
  IPHONE = "IPHONE",
  IPAD = "IPAD",
  IPOD_TOUCH = "IPOD_TOUCH",
  OTHER = "OTHER",
}

export enum DeviceInfoStatus {
  LOGGED_IN = "LOGGED_IN",
  LOGGED_OUT = "LOGGED_OUT",
  HARD_SIGNED_OUT = "HARD_SIGNED_OUT",
}

/** Describes the SyncValue for passkey options in the UI */
export interface PasskeyOptions {
  registered_credentials?: Credential[];
}

/** Describes a public-key credential for a passkey */
export interface Credential {
  /** public key ID */
  id?: string;
  /** Description from browser agent or user definable */
  description?: string;
  /** Epoch time of credential registration */
  registered_at_millis?: number;
  /** Epoch time of last credential usage */
  last_used_at_millis?: number;
}
